import { render, staticRenderFns } from "./Cupons.vue?vue&type=template&id=4cb8ec82&"
import script from "./Cupons.vue?vue&type=script&lang=js&"
export * from "./Cupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports